module.exports = __webpack_public_path__ + "fonts/457d236c21d5d1d52a79f3bc68acc871.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/excess.svg
// module id = 2079
// module chunks = 0